import wrapperFactory from "../util/wrapper-factory.js";

export default async function inviteLinkBuilder() {
  const exported = await wrapperFactory({ name: "invite-link-builder-v1" });
  return exported.default;
}
